import { LinkOutlined } from "@ant-design/icons";
import { Popover, Input, Button, Space, Checkbox, Flex } from "antd";
import React, { useState } from "react";
import { useTranslation } from 'react-i18next';

type InsertLinkProps = {
  onClick: (value: string) => void;
  style: React.CSSProperties;
};

const InsertLink: React.FC<InsertLinkProps> = ({ onClick, style }) => {
  const { t } = useTranslation();
  const [popoverVisible, setPopoverVisible] = useState(false);
  const [url, setUrl] = useState("");

  const handleIconClick = () => {
    setPopoverVisible(!popoverVisible);
  };

  const handleOk = () => {
    setPopoverVisible(false);
    if (url && onClick) {
      onClick(url);
      setUrl(""); // Clear the input after inserting the link
    }
  };

  const content = (
    <Space direction="vertical" style={{ width: 200, padding:"10px 20px" }}>
      <div style={{fontWeight:600, fontSize: 15}}>{t('Insert Link')}</div>
      <Input
        placeholder={t('Enter URL')}
        value={url}
        onChange={(e) => setUrl(e.target.value)}
        onPressEnter={handleOk}
      />
      <Button type="primary" onClick={handleOk}>
        OK
      </Button>
    </Space>
  );

  return (
    <Popover
      content={content}
      // title="Insert Link"
      trigger="click"
      open={popoverVisible}
      onOpenChange={(visible) => setPopoverVisible(visible)}
    >
      <LinkOutlined style={{color: "#666"}} onClick={handleIconClick} />
    </Popover>
  );
};

export default InsertLink;
